import type { TLiabilityFieldArrayName } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/liabilities/types.ts';

export const LIABILITY_TABLE_HEADERS = [
  'Кредитор',
  'Вид зобов’язання',
  'Сума, тис. од.',
  'Ціль / призначення',
  'Дата виникнення',
  'Дата погашення',
  'Рядок фінансової звітності',
] as const;

export const LIABILITY_TABLE_COLUMN_WIDTHS = [
  '22%',
  '14%',
  '12%',
  '22%',
  '10%',
  '10%',
  '10%',
] as const;

export const LIABILITY_TABLE_MIN_WIDTH = 1260;

export const LIABILITY_GROUPS: { name: TLiabilityFieldArrayName; title: string }[] = [
  {
    name: 'liabilitiesAnnual',
    title: '8.1. Розшифровка рядків Форми №1 / №1-м / №1-мс за річною звітністю',
  },
  {
    name: 'liabilitiesQuarterly',
    title: '8.2. Розшифровка рядків Форми №1 / №1-м / №1-мс за квартальною звітністю',
  },
];
